import React, { createContext, useState, useContext } from "react";
import Modal from "../components/Modal"; // Importe o modal aqui

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: "",
    message: "",
    onConfirm: () => {},
    type: "alert",
  });

  const showNotification = ({ title, message, onConfirm, type = "alert" }) => {
    setModalState({
      isOpen: true,
      title,
      message,
      onConfirm: () => {
        if (onConfirm) onConfirm();
        hideNotification();
      },
      type,
    });
  };

  const hideNotification = () => {
    setModalState({ ...modalState, isOpen: false });
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <Modal
        isOpen={modalState.isOpen}
        title={modalState.title}
        message={modalState.message}
        onConfirm={modalState.onConfirm}
        type={modalState.type}
        onClose={hideNotification}
      />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  return useContext(NotificationContext);
};
